<template>
    <div class="main-wrappers top-bar" style="background-color: white;">
      <div v-if="isDataLoading" class="p-3">
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>
      <div v-else-if="app">
        <div style="padding: 24px;">
            <router-link :to="!appType?'/marketplace-apps-review?t=apps':`/marketplace-apps-review?type=${appType}&t=apps`" style="display: flex; justify-content: start; color: black;"><u><i class="fa fa-thin fa-arrow-left"></i>{{ " Back to Dashboard" }}</u></router-link>
            <div style="display: flex;padding-top: 1rem; padding-bottom: 1rem;" > 
                <div style="justify-items: start; display: flex;width: 77%; ">
                    <div style="width:8%;" class="position-center content-fit">
                        <img v-if="app.logoUrl" :src="app.logoUrl" height="80px" width="80px" style="border-radius: 5px;object-fit: scale-down"/>
                        <div v-else style="border-width: 0px;background-color: grey;height:80px;width: 80px;border-radius: 5px; display: flex;align-items: center; justify-content: center;"><i class="fa fa-duotone fa-plus" style="color: white;"></i></div>
                    </div>
                    <div style="width: 92%; padding-left: 0.5rem;">
                        <div style="display: inline;justify-items: start;width: 100%;">
                            <div style="display:flex;gap: 0.5rem;">
                                <div class="heading-font truncate">{{ app.name }}</div>
                                <div class="position-center">
                                    <div class="tag info subtitle-font" style="padding: 0.25rem; padding-inline: 0.5rem;display: flex;"> <i class="fa fa-sharp fa-clock"/><span style="padding-left: 0.25rem;">{{ formatVersion(app.version) }}</span> </div>
                                </div>
                                <div class="position-center" v-if="app.isWhiteLabelFriendly">
                                    <div class="tag info subtitle-font" style="padding: 0.25rem; padding-inline: 0.5rem;display: flex;"><span style="padding-left: 0.25rem;">Whitelabel App</span> </div>
                                </div>
                            </div>
                            <div class="subtitle-font" style="display: flex;justify-items: start; "> <div class="truncate">{{ app.tagline }} </div></div>
                            <div v-if="appType==='Pending Review'" style="display: flex;justify-items: start; gap:0.5rem;padding-top: 0.5rem;">
                                <button id="approve-app" class="btn btn-primary" @click="reviewApp(false)" size="sm">Approve</button>
                                <button id="disapprove-app" class="btn danger-btn" @click="reviewApp(true)" size="sm">Disapprove</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 23%;">
                    <div style="width: 100%;">
                        <div style="display: flex; justify-content: start; gap: 0.225rem;">
                            <div class="tag info">{{ app.private ? "Private": "Public"}}</div>
                            <div v-if="app.userTypes" class="tag info">{{ app.userTypes.join(', ') }}</div>
                            <div v-if="appType" :class="appType==='Approved'? 'tag success toCapitalFirst':(appType==='Disapproved'?'tag danger toCapitalFirst':'tag warning toCapitalFirst' )"><span class="mx-1">{{ appType }}</span></div>                
                        </div>
                        <div style="gap:0.25rem;display: flex; justify-items: start;"><span>Submitted on:</span><b>{{ formatTime(app.submittedOn) }}</b></div>
                        <div style="gap:0.25rem;display: flex; justify-items: start;"><span>Approved on:</span><b>{{ app.approvedOn ? formatTime(app.approvedOn) : "-" }}</b></div>
                        <div style="gap:0.25rem;display: flex; justify-items: start;"><span>SLA:</span><b>{{ app.sla ? app.sla : "-" }}</b></div>
                    </div>
                </div>

            </div>
        </div>
        <b-tabs lazy >            
            <b-tab title="Overview" active >
            <AppOverview :data="app"/>
            </b-tab>
            <b-tab title="Changes">
            <AppReviewDiff :appData="app"/>
            </b-tab>            
            <b-tab title="Activity log">
            <ActivityLog :appId="appId"/>
            </b-tab>            
        </b-tabs>
        <modal v-if="showModal" :max-width="600">
            <div class="modal-box">
                <div>
                    <div class="modal-header" style="border-bottom:0px;padding: 0px;background-color: white">
                        <div v-if="modalType==='Approve'" style="border-radius: 50%; width: 35px; height: 35px;background-color: #ECFDF3;display: flex;justify-content: center;align-items: center;">
                            <div style="border-radius: 50%; width: 25px; height: 25px;background-color: #D1FADF;">
                                <i class="fa fa-check" style="color: #039855"></i>
                            </div>
                        </div>
                        <div v-else style="border-radius: 50%; width: 35px; height: 35px;background-color:#FFFAEB;display: flex;justify-content: center;align-items: center;">
                            <div style="border-radius: 50%; width: 25px; height: 25px;background-color: #FEF0C7">
                                <i class="fa fa-info" style="color:#FDB022"></i>
                            </div>
                        </div>
                        <i class="fa fa-times modal-close-icon" @click="confirmationModal(false)" />                    
                    </div>
                    <div class="text-left pb-4" style="padding-top:1rem;">
                        <div v-if="modalType==='Approve'" >
                            <h5><b>Are you sure you want to Approve this app?</b></h5>
                            <div class="sub-text">On approving, the app will get listed on GoHighLevel marketplace and all customers can access the same.</div>
                        </div>
                        <div v-else>
                            <h5><b>Are you sure you want to Disapprove this app?</b></h5>
                            <div class="sub-text">Please share your feedback with the developer on changes required to approve the App.</div>                        
                        </div>
                    </div>
                </div>
                <div id="modal-body" class="text-left">
                    <textarea id="comment-section" type="textarea" placeholder="Add comment" rows="4" v-model="comment" required class="hl_input--wrap my-1"/> 
                    <div v-if="modalType==='Approve'">
                        <input id="sendMail" type="checkbox" class="mr-2" v-model="shareViaMail" />                        
                        <label for="send" class="sub-text">Share comments with the App developer via email</label>
                    </div>
                    <div v-else class="sub-text">
                        On disapproving, an email will be sent to the App developer with the comments.
                    </div>
                </div>
                <div id="modal-footer" style="width:100%;display: flex; gap:0.5rem;" class="pt-4">
                    <button class="btn" @click="confirmationModal(false)" style="width: 50%;" :disabled="isSaving">Cancel</button>
                    <button v-if="modalType==='Approve'" class="btn btn-primary" @click="submit(false)" style="width: 50%;" :disabled="isSaving">Approve</button>
                    <button v-else class="btn btn-danger" @click="submit(true)" style="width: 50%;" :disabled="isSaving">Disapprove</button>
                </div>
            </div>
        </modal>
      </div>
      <div v-else class="p-3">
        <router-link to="/marketplace-apps-review" style="display: flex; justify-content: start; color: black;"><u><i class="fa fa-thin fa-arrow-left"></i>{{ " Back to Dashboard" }}</u></router-link>        
        <div class="heading-font">App not found</div>
      </div>
    </div>
</template>
  
<script>
import * as moment from "moment";
import Modal from "@/components/common/Modal.vue";
import { OAuthService } from "@/services"
import AppOverview from "@/components/marketplace/marketplaceAppsReviewPortal/AppOverview"
import ActivityLog from "@/components/marketplace/marketplaceAppsReviewPortal/ActivityLog"
import AppReviewDiff from "@/components/marketplace/marketplaceAppsReviewPortal/AppReviewDiff";
import { ReviewStatus } from "@/constants/Oauth.ts"

export default {
    components:{AppOverview, ActivityLog, AppReviewDiff, Modal},
    data() {
      return {
        appId: this.$route.params.id,
        appType: this.$route.query.type,
        app: undefined,
        showModal:false,
        modalType:undefined,
        comment:undefined,
        shareViaMail:false,
        isSaving:false,
        isDataLoading:false
      }
    },
    async created() {
        this.app = this.$store.getters['oauth_client_app/getApp']
        if(!this.app){
          await this.fetchData()
        }       
    },
    methods: {
      async fetchData() {
        try {
          this.isDataLoading = true;
          let response
          const query ={
            appId:this.appId,
            limit:1,
            skip:0
          }
          if(this.appType === "Approved"){
            response = await OAuthService.Client.Review.getReviewedApps(query)
            this.app = response.data.apps && response.data.apps.length>0 ? response.data.apps[0] : undefined
          }else{
            query['status'] = this.appType === "Disapproved" ? ReviewStatus.DISAPPROVED : ReviewStatus.IN_REVIEW
            response = await OAuthService.Client.Review.getAppsForReview(query) 
            this.app = response.data.apps && response.data.apps.length>0 ? response.data.apps[0] : undefined
          }
        } catch(error){
          console.error(error);
          alert(error.message || error.message[0] || "Something went wrong");
        }finally{
          this.isDataLoading = false
        }
      },
      async submit(isRejected) {
        try {
          if(!this.comment){            
            alert("Comment is mandatory");
            return
          }
          this.isSaving = true;
          const currentUser = this.$store.state?.auth?.user         
          const data = {
            approvalStatus: isRejected ? "disapproved" : "approved",
            approvedBy: currentUser.email,
            isShareEnabled: isRejected ? true : this.shareViaMail,
            comment: this.comment           
          }          
          const response = await OAuthService.Client.Review.createReview(this.appId, data)
          if(response.data && response.data.success){
            this.appType = isRejected ? "Disapproved" : "Approved"
            alert(response.data.message || "Success");
            //this.$router.push(`/marketplace-apps-review/${this.appId}?type=${this.appType}`)
          }          
          this.confirmationModal(false)
        } catch(error){
          console.error(error);
          alert(error.message || error.message[0] || "Something went wrong");
          this.confirmationModal(false)
        }finally{
            this.isSaving = false            
        }
      },
      formatTime(time){
        return moment(time).format(
          "MMM DD, YYYY"
        )
      },
      formatVersion(version){
        return parseFloat(version || 1).toFixed(1)
      },
      reviewApp(isRejected){
        this.modalType = isRejected ? "Disapprove": "Approve"
        this.shareViaMail = isRejected ? true : false
        this.confirmationModal(true)
      },
      confirmationModal(value){
        this.showModal=value
      }
    }
  };
</script>
<style scoped>
.top-bar{
    margin: -24px;
}
.position-center{
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.heading-font{
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    color: #475467;    
}
.subtitle-font{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #6B7280;
}
.toCapitalFirst {
    text-transform: capitalize;
}
  
.tag{    
    border-radius: 13px;
    color: white;
    text-align: center;
  }
  .info {
    color:#344054;
    background: #F2F4F7;
    mix-blend-mode: multiply;
    padding-left: 0.25rem;
    padding-right: 0.25rem; 
  }
  .success {
    background: #12B76A;
  }
  .danger {
    background: #D92D20;
  }
  .danger-btn {
    background: #FEF3F2;
    color: #B42318;
  }
  .warning {
    background: #F79009;
    padding-left: 0.25rem;
    padding-right: 0.25rem; 
  }
  .truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
}
.sub-text {
    color: #6B7280;font-size: 0.875rem;
}
</style>